export const data0=[
    {img:"https://images.bewakoof.com/uploads/grid/app/b2g1-1x1-common-1670505865.jpg"},
    {img:"https://images.bewakoof.com/uploads/grid/app/oof-sale-endstom-1x1-common-1671025899.gif"},
    {img:"https://images.bewakoof.com/uploads/grid/app/revised-buy3-banner-1670840080.jpg"},
  {img:"https://images.bewakoof.com/uploads/grid/app/revamped-banner-1x1-copy-04-1670505869.jpg"},
{img:"https://images.bewakoof.com/uploads/grid/app/winter-looks-common-1670589179.jpg"}]

export const data=[
    {img:"https://images.bewakoof.com/uploads/grid/app/Thumbnail-New-Arrivals-Common-1668508339.jpg",id:1,title:"New Arrivals"},
    {img:"https://images.bewakoof.com/uploads/grid/app/hotdeals-2-1668491210.jpg",id:2,title:"Hot Deals"},
    {img:"https://images.bewakoof.com/uploads/grid/app/Thumbnail-Collabs-Common-1668508338.jpg",id:3,title:"Official Collaborations"},
    {img:"https://images.bewakoof.com/uploads/grid/app/last-size-new-thumbnaik-1668508337.jpg",id:4,title:"Last Sizes Left"},
    {img:"https://images.bewakoof.com/uploads/grid/app/new-thumbnail-icon-2022-copy-1669723278.jpg",id:5,title:"Plus Size"},
    {img:"https://images.bewakoof.com/uploads/grid/app/me-shirt-thumbnail-1668508337.jpg",id:6,title:"Customiztion"},
    {img:"https://images.bewakoof.com/uploads/grid/app/image-1668598708.png",id:7,title:"Coupon Offers"},
    {img:"https://images.bewakoof.com/uploads/grid/app/vote-thumbnail-1668508339.jpg",id:8,title:"Vote For Designs"}]

    export const data1=[
        {img:"https://images.bewakoof.com/uploads/grid/app/category-box-new-printed-tees-1668765004.jpg",id:1},
        {img:"https://images.bewakoof.com/uploads/grid/app/category-box-new-e-1670938024.jpg",id:2},
        {img:"https://images.bewakoof.com/uploads/grid/app/category-box-new-1-1670504700.jpg",id:3},
        {img:"https://images.bewakoof.com/uploads/grid/app/category-box-new-d-1670923576.jpg",id:4},
        {img:"https://images.bewakoof.com/uploads/grid/app/category-box-new-2-1670504700.jpg",id:5},
        {img:"https://images.bewakoof.com/uploads/grid/app/category-box-new-7-1670503951.jpg",id:6}
        ]

        export const data2=[
            {img:"https://images.bewakoof.com/uploads/grid/app/category-box-new-fullsleevetees-1668773243.jpg",id:1},
            {img:"https://images.bewakoof.com/uploads/grid/app/category-box-new-c-1670923575.jpg",id:2},
            {img:"https://images.bewakoof.com/uploads/grid/app/category-box-new-4-1670504697.jpg",id:3},
            {img:"https://images.bewakoof.com/uploads/grid/app/category-box-new-6-1670504698.jpg",id:4},
            {img:"https://images.bewakoof.com/uploads/grid/app/category-box-new-5-1670504699.jpg",id:5},
            {img:"https://images.bewakoof.com/uploads/grid/app/category-box-new-boyfriend-tees-1668773241.jpg",id:6},
            ]

    export const data3=[
        {
            "id": "28",
            "gender": "female",
            "category": "shirt",
            "image": "https://images.bewakoof.com/t320/women-s-solid-v-neck-half-sleeve-red-casual-shirt-353228-1635869647-5.jpg",
            "name": "Women's Solid V-Neck Half Sleeve Red Casual Shirt",
            "price": "399",
            "canceledprice": "1099",
            "tribe": "₹ 369 For TriBe Members"
          },
          {
            "id": "29",
            "gender": "female",
            "category": "kurta",
            "image": "https://images.bewakoof.com/t320/women-s-printed-long-kurti-dress-364700-1635869709-1.jpg",
            "name": "Women's Printed Long Kurti Dress",
            "price": "499",
            "canceledprice": "1849",
            "tribe": "₹ 459 For TriBe Members"
          },
          {
            "id": "30",
            "gender": "female",
            "category": "kurta",
            "image": "https://images.bewakoof.com/t320/womens-mid-printed-kurta-318121-1640351218-1.jpg",
            "name": "Women's Green All Over Printed Kurta",
            "price": "499",
            "canceledprice": "1399",
            "tribe": "₹ 459 For TriBe Members"
          },
          {
            "id": "31",
            "gender": "female",
            "category": "shirt",
            "image": "https://images.bewakoof.com/t320/women-s-printed-relaxed-short-sleeves-shirt-364675-1635869581-1.jpg",
            "name": "Women's Printed Relaxed Short Sleeves Shirt",
            "price": "499",
            "canceledprice": "1399",
            "tribe": "₹ 459 For TriBe Members"
          },
          {
            "id": "32",
            "gender": "male",
            "category": "shirt",
            "image": "https://images.bewakoof.com/t320/women-s-all-over-printed-tie-hem-half-sleeve-casual-white-shirt-353239-1638215062-7.jpg",
            "name": "Women's All Over Printed Tie Hem Half Sleeve Casual White Shirt",
            "price": "449",
            "canceledprice": "1349",
            "tribe": "₹ 419 For TriBe Members"
          },
          {
            "id": "24",
            "gender": "male",
            "category": "Tshirt",
            "image": "https://images.bewakoof.com/t320/sunset-block-half-sleeve-t-shirt-271582-1637854985-1.jpg",
            "name": "Sunset Block Half Sleeve T-Shirt",
            "price": "399",
            "canceledprice": "499",
            "tribe": "₹ 359 For TriBe Members"
          },
          {
            "id": "25",
            "category": "Tshirt",
            "gender": "male",
            "image": "https://images.bewakoof.com/t320/busy-doin-nothing-half-sleeve-t-shirt-287587-1632149262-4.jpg",
            "name": "Men's Blue Busy Doing Nothing T-shirt",
            "price": "399",
            "canceledprice": "499",
            "tribe": "₹ 359 For TriBe Members"
          },
          {
            "id": "26",
            "category": "Tshirt",
            "gender": "male",
            "image": "https://images.bewakoof.com/t320/iron-man-of-war-half-sleeve-t-shirt-avl-220650-1635867920-4.jpg",
            "name": "Men's Black Iron Man Of War T-shirt",
            "price": "399",
            "canceledprice": "499",
            "tribe": "₹ 359 For TriBe Members"
          },
          {
            "id": "27",
            "category": "Tshirt",
            "gender": "male",
            "image": "https://images.bewakoof.com/t320/save-our-home-half-sleeve-t-shirt-276160-1637996048-1.jpg",
            "name": "Men's Black Save Our Home T-shirt",
            "price": "399",
            "canceledprice": "499",
            "tribe": "₹ 719 For TriBe Members"
          }
    ]